(function(){
  if(window.__maAtelierInit) return; window.__maAtelierInit = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  /* Split headings into words for staggered line reveals */
  function splitWords(){
    document.querySelectorAll('[data-ma-words]:not(.ma-split)').forEach(function(el){
      el.classList.add('ma-split');
      if(reduced) return;
      var text = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      text.forEach(function(w, i){
        var line = document.createElement('span'); line.className = 'ma-wline';
        var word = document.createElement('span'); word.className = 'ma-word';
        word.textContent = w;
        word.style.transitionDelay = (0.08 + i * 0.07) + 's';
        line.appendChild(word); el.appendChild(line);
        el.appendChild(document.createTextNode(' '));
      });
    });
  }

  /* Reveal on scroll */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('ma-inview'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function observe(){
    document.querySelectorAll('[data-ma-reveal],[data-ma-stagger],[data-ma-clip],[data-ma-words]').forEach(function(el){
      if(el.__maObs) return; el.__maObs = true;
      if(reduced){ el.classList.add('ma-inview'); return; }
      io.observe(el);
    });
  }

  /* Parallax + scroll zoom */
  var pEls = [], zEls = [], ticking = false;
  function collect(){
    pEls = Array.prototype.slice.call(document.querySelectorAll('[data-ma-parallax]'));
    zEls = Array.prototype.slice.call(document.querySelectorAll('[data-ma-zoom]'));
  }
  function frame(){
    ticking = false;
    var vh = window.innerHeight;
    pEls.forEach(function(el){
      var r = el.getBoundingClientRect();
      if(r.bottom < -200 || r.top > vh + 200) return;
      var speed = parseFloat(el.getAttribute('data-ma-parallax')) || 0.15;
      if(isMobile) speed *= 0.45;
      var delta = (r.top + r.height / 2 - vh / 2) * -speed;
      el.style.transform = 'translate3d(0,' + delta.toFixed(1) + 'px,0)';
    });
    zEls.forEach(function(el){
      var r = el.getBoundingClientRect();
      if(r.bottom < 0 || r.top > vh) return;
      var p = Math.min(1, Math.max(0, 1 - (r.top + r.height * 0.5 - vh * 0.5) / vh));
      var img = el.querySelector('img'); if(!img) return;
      var s = 1.12 - 0.12 * p;
      img.style.transform = 'scale(' + Math.max(1, s).toFixed(4) + ')';
    });
  }
  function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(frame); } }

  function init(){
    splitWords(); observe(); collect();
    if(!reduced){
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      frame();
    }
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', function(){ init(); });
})();
